import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=b8004f00&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=b8004f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8004f00",
  null
  
)

export default component.exports